import { render, staticRenderFns } from "./CollarCartCenter.vue?vue&type=template&id=4b20df5c&scoped=true&"
import script from "./CollarCartCenter.vue?vue&type=script&lang=js&"
export * from "./CollarCartCenter.vue?vue&type=script&lang=js&"
import style0 from "./CollarCartCenter.vue?vue&type=style&index=0&id=4b20df5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b20df5c",
  null
  
)

export default component.exports